<script setup lang="ts">
import Button from '@afinius/ui-framework/Button/Button.vue';
import Cluster from '@afinius/ui-framework/Cluster/Cluster.vue';
import SecondaryNav from '@afinius/ui-framework/SecondaryNav/SecondaryNav.vue';
import SecondaryNavItem from '@afinius/ui-framework/SecondaryNav/SecondaryNavItem.vue';
import Stack from '@afinius/ui-framework/Stack/Stack.vue';
import { ArrowUturnLeftIcon } from '@heroicons/vue/24/solid';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <Cluster shouldStackMobile>
    <SecondaryNav>
      <Button appearance="clear" :to="{ name: 'home' }">
        <template #icon>
          <ArrowUturnLeftIcon />
        </template>

        {{ t('personal-settings.back-to-home') }}
      </Button>

      <SecondaryNavItem :to="{ name: 'personal-settings.profile' }">
        {{ t('user.profile') }}
      </SecondaryNavItem>

      <SecondaryNavItem :to="{ name: 'personal-settings.security' }">
        {{ t('user.security') }}
      </SecondaryNavItem>
    </SecondaryNav>

    <Stack width="100%" :style="{ paddingTop: '1rem' }">
      <RouterView />
    </Stack>
  </Cluster>
</template>
